module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('img', {
    staticClass: "back",
    attrs: {
      "alt": "Page 4",
      "src": "images/graphics_4.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.000000, 0.0000, 0.0000, 1.000000, 0,0)",
      "width": "738px"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 578.6428)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "19px"
    }
  }, [_vm._v("Text")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "18px",
      "width": "34px"
    }
  }, [_vm._v("copyright")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs ",
    staticStyle: {
      "position": "absolute",
      "left": "57px",
      "width": "12px"
    }
  }, [_vm._v("©")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "66px",
      "width": "24px"
    }
  }, [_vm._v("2010")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "86px",
      "width": "12px"
    }
  }, [_vm._v("by")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "98px",
      "width": "32px"
    }
  }, [_vm._v("Deborah")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "132px",
      "width": "25px"
    }
  }, [_vm._v("Lakritz ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 589.2189)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s11ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "39px"
    }
  }, [_vm._v("Illustrations ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 589.2189)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "45px",
      "width": "34px"
    }
  }, [_vm._v("copyright")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs ",
    staticStyle: {
      "position": "absolute",
      "left": "83px",
      "width": "12px"
    }
  }, [_vm._v("©")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "93px",
      "width": "24px"
    }
  }, [_vm._v("2010")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "113px",
      "width": "25px"
    }
  }, [_vm._v("Lerner")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s34ls",
    staticStyle: {
      "position": "absolute",
      "left": "139px",
      "width": "37px"
    }
  }, [_vm._v("Publishing")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s17ls",
    staticStyle: {
      "position": "absolute",
      "left": "179px",
      "width": "25px"
    }
  }, [_vm._v("Group")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 610.3791)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "13px"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "10px",
      "width": "21px"
    }
  }, [_vm._v("rights")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s15ls",
    staticStyle: {
      "position": "absolute",
      "left": "34px",
      "width": "33px"
    }
  }, [_vm._v("reserved.")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s41ls",
    staticStyle: {
      "position": "absolute",
      "left": "70px",
      "width": "43px"
    }
  }, [_vm._v("International ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 610.3791)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "120px",
      "width": "34px"
    }
  }, [_vm._v("copyright")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s17ls",
    staticStyle: {
      "position": "absolute",
      "left": "158px",
      "width": "31px"
    }
  }, [_vm._v("secured.")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "192px",
      "width": "14px"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s14ls",
    staticStyle: {
      "position": "absolute",
      "left": "205px",
      "width": "16px"
    }
  }, [_vm._v("part")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs ",
    staticStyle: {
      "position": "absolute",
      "left": "222px",
      "width": "11px"
    }
  }, [_vm._v("of")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "233px",
      "width": "15px"
    }
  }, [_vm._v("this")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs ",
    staticStyle: {
      "position": "absolute",
      "left": "249px",
      "width": "20px"
    }
  }, [_vm._v("book")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "270px",
      "width": "18px"
    }
  }, [_vm._v("may")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs ",
    staticStyle: {
      "position": "absolute",
      "left": "287px",
      "width": "13px"
    }
  }, [_vm._v("be")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s5ls",
    staticStyle: {
      "position": "absolute",
      "left": "299px",
      "width": "23px"
    }
  }, [_vm._v("repro- ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 620.9621)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "26px"
    }
  }, [_vm._v("duced,")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs ",
    staticStyle: {
      "position": "absolute",
      "left": "26px",
      "width": "24px"
    }
  }, [_vm._v("stored")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "52px",
      "width": "10px"
    }
  }, [_vm._v("in")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "61px",
      "width": "8px"
    }
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "68px",
      "width": "30px"
    }
  }, [_vm._v("retrieval")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "101px",
      "width": "28px"
    }
  }, [_vm._v("system,")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs ",
    staticStyle: {
      "position": "absolute",
      "left": "131px",
      "width": "11px"
    }
  }, [_vm._v("or")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s17ls",
    staticStyle: {
      "position": "absolute",
      "left": "141px",
      "width": "39px"
    }
  }, [_vm._v("transmitted")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "186px",
      "width": "10px"
    }
  }, [_vm._v("in")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "195px",
      "width": "16px"
    }
  }, [_vm._v("any")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s14ls",
    staticStyle: {
      "position": "absolute",
      "left": "211px",
      "width": "18px"
    }
  }, [_vm._v("form")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs ",
    staticStyle: {
      "position": "absolute",
      "left": "231px",
      "width": "11px"
    }
  }, [_vm._v("or")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "241px",
      "width": "12px"
    }
  }, [_vm._v("by")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "253px",
      "width": "16px"
    }
  }, [_vm._v("any")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s32ls",
    staticStyle: {
      "position": "absolute",
      "left": "269px",
      "width": "259px"
    }
  }, [_vm._v("means—electron- ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 631.5422)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "12px"
    }
  }, [_vm._v("ic,")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s32ls",
    staticStyle: {
      "position": "absolute",
      "left": "10px",
      "width": "43px"
    }
  }, [_vm._v("mechanical,")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "56px",
      "width": "49px"
    }
  }, [_vm._v("photocopying, ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 631.5422)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s17ls",
    staticStyle: {
      "position": "absolute",
      "left": "113px",
      "width": "36px"
    }
  }, [_vm._v("recording,")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs ",
    staticStyle: {
      "position": "absolute",
      "left": "153px",
      "width": "11px"
    }
  }, [_vm._v("or")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "163px",
      "width": "164px"
    }
  }, [_vm._v("otherwise—without ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 631.5422)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "238px",
      "width": "14px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "253px",
      "width": "26px"
    }
  }, [_vm._v("written")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s17ls",
    staticStyle: {
      "position": "absolute",
      "left": "282px",
      "width": "38px"
    }
  }, [_vm._v("permission")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 642.1184)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs ",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "11px"
    }
  }, [_vm._v("of")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s68ls",
    staticStyle: {
      "position": "absolute",
      "left": "10px",
      "width": "31px"
    }
  }, [_vm._v("Kar-Ben")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s42ls",
    staticStyle: {
      "position": "absolute",
      "left": "41px",
      "width": "39px"
    }
  }, [_vm._v("Publishing,")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "83px",
      "width": "18px"
    }
  }, [_vm._v("Inc.,")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "101px",
      "width": "26px"
    }
  }, [_vm._v("except")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs ",
    staticStyle: {
      "position": "absolute",
      "left": "129px",
      "width": "13px"
    }
  }, [_vm._v("for")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "143px",
      "width": "14px"
    }
  }, [_vm._v("the")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 221.2924, 642.1184)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s29ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "32px"
    }
  }, [_vm._v("inclusion")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs ",
    staticStyle: {
      "position": "absolute",
      "left": "35px",
      "width": "11px"
    }
  }, [_vm._v("of")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s15ls",
    staticStyle: {
      "position": "absolute",
      "left": "46px",
      "width": "18px"
    }
  }, [_vm._v("brief")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s16ls",
    staticStyle: {
      "position": "absolute",
      "left": "66px",
      "width": "25px"
    }
  }, [_vm._v("quotes")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "94px",
      "width": "10px"
    }
  }, [_vm._v("in")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "103px",
      "width": "12px"
    }
  }, [_vm._v("an")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "114px",
      "width": "51px"
    }
  }, [_vm._v("acknowledged")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 652.6936)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s33ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "28px"
    }
  }, [_vm._v("review. ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 673.8547)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px",
      "left": "6px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s28ls",
    staticStyle: {
      "position": "absolute",
      "left": "-6px",
      "width": "37px"
    }
  }, [_vm._v("KAR-BEN")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 97.2397, 673.8547)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s42ls",
    staticStyle: {
      "position": "absolute",
      "left": "6px",
      "width": "39px"
    }
  }, [_vm._v("Publishing,")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "48px",
      "width": "16px"
    }
  }, [_vm._v("Inc.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 684.4309)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "9px"
    }
  }, [_vm._v("A")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s41ls",
    staticStyle: {
      "position": "absolute",
      "left": "6px",
      "width": "29px"
    }
  }, [_vm._v("division")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs ",
    staticStyle: {
      "position": "absolute",
      "left": "37px",
      "width": "11px"
    }
  }, [_vm._v("of")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "48px",
      "width": "25px"
    }
  }, [_vm._v("Lerner")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s34ls",
    staticStyle: {
      "position": "absolute",
      "left": "74px",
      "width": "37px"
    }
  }, [_vm._v("Publishing")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s17ls",
    staticStyle: {
      "position": "absolute",
      "left": "114px",
      "width": "25px"
    }
  }, [_vm._v("Group ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 695.0051)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "19px"
    }
  }, [_vm._v("241")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s17ls",
    staticStyle: {
      "position": "absolute",
      "left": "15px",
      "width": "18px"
    }
  }, [_vm._v("First")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s41ls",
    staticStyle: {
      "position": "absolute",
      "left": "34px",
      "width": "29px"
    }
  }, [_vm._v("Avenue")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s17ls",
    staticStyle: {
      "position": "absolute",
      "left": "63px",
      "width": "22px"
    }
  }, [_vm._v("North ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 705.5812)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s33ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "44px"
    }
  }, [_vm._v("Minneapolis,")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "47px",
      "width": "16px"
    }
  }, [_vm._v("MN")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 124.5541, 705.5812)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "29px"
    }
  }, [_vm._v("55401")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s75ls",
    staticStyle: {
      "position": "absolute",
      "left": "29px",
      "width": "26px"
    }
  }, [_vm._v("U.S.A. ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 716.1574)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s68ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "156px"
    }
  }, [_vm._v("800-4KARBEN ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 737.3176)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s14ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "30px"
    }
  }, [_vm._v("Website")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s18ls",
    staticStyle: {
      "position": "absolute",
      "left": "31px",
      "width": "30px"
    }
  }, [_vm._v("address:")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "font-color": "black",
      "text-decoration": "none"
    },
    attrs: {
      "href": "http://www.karben.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s41ls",
    staticStyle: {
      "position": "absolute",
      "left": "64px",
      "width": "60px"
    }
  }, [_vm._v("www.karben.com ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 758.4787)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s17ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "39px"
    }
  }, [_vm._v("Distributed")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "43px",
      "width": "12px"
    }
  }, [_vm._v("by")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "55px",
      "width": "23px"
    }
  }, [_vm._v("Open")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "78px",
      "width": "21px"
    }
  }, [_vm._v("Road")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "99px",
      "width": "36px"
    }
  }, [_vm._v("Integrated")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "140px",
      "width": "26px"
    }
  }, [_vm._v("Media,")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "166px",
      "width": "16px"
    }
  }, [_vm._v("Inc. ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 769.0529)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "22px"
    }
  }, [_vm._v("ISBN")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s86ls",
    staticStyle: {
      "position": "absolute",
      "left": "23px",
      "width": "78px"
    }
  }, [_vm._v("978-1-4804-5291-6")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s14ls",
    staticStyle: {
      "position": "absolute",
      "left": "102px",
      "width": "29px"
    }
  }, [_vm._v("(ebook) ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 790.2141)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s33ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "27px"
    }
  }, [_vm._v("Library")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs ",
    staticStyle: {
      "position": "absolute",
      "left": "27px",
      "width": "11px"
    }
  }, [_vm._v("of")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s18ls",
    staticStyle: {
      "position": "absolute",
      "left": "38px",
      "width": "34px"
    }
  }, [_vm._v("Congress")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s23ls",
    staticStyle: {
      "position": "absolute",
      "left": "75px",
      "width": "126px"
    }
  }, [_vm._v("Cataloging-in-Publication ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 790.2141)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s42ls",
    staticStyle: {
      "position": "absolute",
      "left": "166px",
      "width": "12px"
    }
  }, [_vm._v("Data ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 811.3742)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "27px"
    }
  }, [_vm._v("Lakritz,")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "28px",
      "width": "34px"
    }
  }, [_vm._v("Deborah. ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 821.9504)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "19px",
      "width": "17px"
    }
  }, [_vm._v("Say")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s41ls",
    staticStyle: {
      "position": "absolute",
      "left": "34px",
      "width": "22px"
    }
  }, [_vm._v("hello,")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "56px",
      "width": "17px"
    }
  }, [_vm._v("Lily")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "71px",
      "width": "8px"
    }
  }, [_vm._v("/")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "76px",
      "width": "12px"
    }
  }, [_vm._v("by")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "88px",
      "width": "32px"
    }
  }, [_vm._v("Deborah")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "121px",
      "width": "25px"
    }
  }, [_vm._v("Lakritz")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs ",
    staticStyle: {
      "position": "absolute",
      "left": "148px",
      "width": "7px"
    }
  }, [_vm._v(";")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "152px",
      "width": "35px"
    }
  }, [_vm._v("illustrated")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "191px",
      "width": "12px"
    }
  }, [_vm._v("by")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "202px",
      "width": "26px"
    }
  }, [_vm._v("Martha")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s34ls",
    staticStyle: {
      "position": "absolute",
      "left": "229px",
      "width": "26px"
    }
  }, [_vm._v("Aviles. ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 832.5266)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "28px",
      "width": "10px"
    }
  }, [_vm._v("p.")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "43px",
      "width": "16px"
    }
  }, [_vm._v("cm. ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2192, 843.1018)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s42ls",
    staticStyle: {
      "position": "absolute",
      "left": "19px",
      "width": "36px"
    }
  }, [_vm._v("Summary:")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "57px",
      "width": "17px"
    }
  }, [_vm._v("Lily")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s33ls",
    staticStyle: {
      "position": "absolute",
      "left": "72px",
      "width": "23px"
    }
  }, [_vm._v("wants")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs ",
    staticStyle: {
      "position": "absolute",
      "left": "97px",
      "width": "11px"
    }
  }, [_vm._v("to")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs ",
    staticStyle: {
      "position": "absolute",
      "left": "107px",
      "width": "13px"
    }
  }, [_vm._v("go")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s42ls",
    staticStyle: {
      "position": "absolute",
      "left": "119px",
      "width": "18px"
    }
  }, [_vm._v("with")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "138px",
      "width": "14px"
    }
  }, [_vm._v("her")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "152px",
      "width": "26px"
    }
  }, [_vm._v("mother")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs ",
    staticStyle: {
      "position": "absolute",
      "left": "181px",
      "width": "11px"
    }
  }, [_vm._v("to")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s33ls",
    staticStyle: {
      "position": "absolute",
      "left": "191px",
      "width": "17px"
    }
  }, [_vm._v("visit")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "209px",
      "width": "14px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s16ls",
    staticStyle: {
      "position": "absolute",
      "left": "223px",
      "width": "26px"
    }
  }, [_vm._v("people")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s41ls",
    staticStyle: {
      "position": "absolute",
      "left": "251px",
      "width": "18px"
    }
  }, [_vm._v("who")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s42ls",
    staticStyle: {
      "position": "absolute",
      "left": "270px",
      "width": "16px"
    }
  }, [_vm._v("live")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "285px",
      "width": "10px"
    }
  }, [_vm._v("at")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s75ls",
    staticStyle: {
      "position": "absolute",
      "left": "294px",
      "width": "29px"
    }
  }, [_vm._v("Shalom")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 72.7475, 853.6770)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "27px"
    }
  }, [_vm._v("House,")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "27px",
      "width": "12px"
    }
  }, [_vm._v("an")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s14ls",
    staticStyle: {
      "position": "absolute",
      "left": "38px",
      "width": "29px"
    }
  }, [_vm._v("assisted")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s75ls",
    staticStyle: {
      "position": "absolute",
      "left": "69px",
      "width": "22px"
    }
  }, [_vm._v("living")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s29ls",
    staticStyle: {
      "position": "absolute",
      "left": "92px",
      "width": "27px"
    }
  }, [_vm._v("facility,")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "121px",
      "width": "14px"
    }
  }, [_vm._v("but")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s42ls",
    staticStyle: {
      "position": "absolute",
      "left": "136px",
      "width": "22px"
    }
  }, [_vm._v("when")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "159px",
      "width": "18px"
    }
  }, [_vm._v("they")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "178px",
      "width": "22px"
    }
  }, [_vm._v("arrive")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "201px",
      "width": "15px"
    }
  }, [_vm._v("she")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "216px",
      "width": "33px"
    }
  }, [_vm._v("suddenly")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s15ls",
    staticStyle: {
      "position": "absolute",
      "left": "252px",
      "width": "19px"
    }
  }, [_vm._v("feels")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "272px",
      "width": "18px"
    }
  }, [_vm._v("very")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s42ls",
    staticStyle: {
      "position": "absolute",
      "left": "290px",
      "width": "17px"
    }
  }, [_vm._v("shy. ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 63.2279, 864.2531)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s29ls",
    staticStyle: {
      "position": "absolute",
      "left": "19px",
      "width": "24px"
    }
  }, [_vm._v("ISBN:")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "43px",
      "width": "86px"
    }
  }, [_vm._v("978–0–7613–4511–4")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s29ls",
    staticStyle: {
      "position": "absolute",
      "left": "125px",
      "width": "17px"
    }
  }, [_vm._v("(lib.")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s14ls",
    staticStyle: {
      "position": "absolute",
      "left": "135px",
      "width": "18px"
    }
  }, [_vm._v("bdg.")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs ",
    staticStyle: {
      "position": "absolute",
      "left": "153px",
      "width": "7px"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s42ls",
    staticStyle: {
      "position": "absolute",
      "left": "157px",
      "width": "15px"
    }
  }, [_vm._v("alk.")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "172px",
      "width": "25px"
    }
  }, [_vm._v("paper)")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "202px",
      "width": "14px"
    }
  }, [_vm._v("[1.")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s41ls",
    staticStyle: {
      "position": "absolute",
      "left": "212px",
      "width": "17px"
    }
  }, [_vm._v("Old")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s41ls",
    staticStyle: {
      "position": "absolute",
      "left": "228px",
      "width": "46px"
    }
  }, [_vm._v("age—Fiction.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 72.7416, 874.8811)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "11px"
    }
  }, [_vm._v("2.")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s41ls",
    staticStyle: {
      "position": "absolute",
      "left": "8px",
      "width": "174px"
    }
  }, [_vm._v("Bashfulness—Fiction.]")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "92px",
      "width": "8px"
    }
  }, [_vm._v("I.")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s41ls",
    staticStyle: {
      "position": "absolute",
      "left": "98px",
      "width": "24px"
    }
  }, [_vm._v("Avilés")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s75ls",
    staticStyle: {
      "position": "absolute",
      "left": "121px",
      "width": "27px"
    }
  }, [_vm._v("Junco,")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s33ls",
    staticStyle: {
      "position": "absolute",
      "left": "148px",
      "width": "28px"
    }
  }, [_vm._v("Martha,")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "177px",
      "width": "12px"
    }
  }, [_vm._v("ill.")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "189px",
      "width": "10px"
    }
  }, [_vm._v("II.")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s41ls",
    staticStyle: {
      "position": "absolute",
      "left": "198px",
      "width": "21px"
    }
  }, [_vm._v("Title.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 72.7416, 885.4572)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "62px"
    }
  }, [_vm._v("PZ7.L15934Say")]), _vm._v(" "), _c('span', {
    staticClass: "s12ff s13fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "63px",
      "width": "24px"
    }
  }, [_vm._v("2010 ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.0204, 72.7416, 896.0324)",
      "-webkit-transform-origin": "0px 8.544300px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s12ff s13fs s75ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "38px"
    }
  }, [_vm._v("[E]—dc22")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.1364, 206.3022, 112.1538)",
      "-webkit-transform-origin": "0px 22.475727px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s87ff s1fc s71fs s88ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "15px"
    }
  }, [_vm._v("T ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.1364, 215.6879, 112.1538)",
      "-webkit-transform-origin": "0px 22.475727px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s87ff s3fc s71fs s88ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "20px"
    }
  }, [_vm._v("o")]), _vm._v(" "), _c('span', {
    staticClass: "s87ff s3fc s71fs s89ls",
    staticStyle: {
      "position": "absolute",
      "left": "20px",
      "width": "40px"
    }
  }, [_vm._v("my")]), _vm._v(" "), _c('span', {
    staticClass: "s87ff s3fc s71fs s85ls",
    staticStyle: {
      "position": "absolute",
      "left": "60px",
      "width": "80px"
    }
  }, [_vm._v("family,")]), _vm._v(" "), _c('span', {
    staticClass: "s87ff s3fc s71fs s63ls",
    staticStyle: {
      "position": "absolute",
      "left": "138px",
      "width": "49px"
    }
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "s87ff s3fc s71fs s89ls",
    staticStyle: {
      "position": "absolute",
      "left": "188px",
      "width": "27px"
    }
  }, [_vm._v("to")]), _vm._v(" "), _c('span', {
    staticClass: "s87ff s3fc s71fs s89ls",
    staticStyle: {
      "position": "absolute",
      "left": "215px",
      "width": "40px"
    }
  }, [_vm._v("my")]), _vm._v(" "), _c('span', {
    staticClass: "s87ff s3fc s71fs s85ls",
    staticStyle: {
      "position": "absolute",
      "left": "255px",
      "width": "79px"
    }
  }, [_vm._v("friends")]), _vm._v(" "), _c('span', {
    staticClass: "s87ff s3fc s71fs ",
    staticStyle: {
      "position": "absolute",
      "left": "332px",
      "width": "27px"
    }
  }, [_vm._v("at")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.1364, 220.9682, 143.8940)",
      "-webkit-transform-origin": "0px 22.475727px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s87ff s3fc s71fs s90ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "41px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s87ff s3fc s71fs s64ls",
    staticStyle: {
      "position": "absolute",
      "left": "40px",
      "width": "68px"
    }
  }, [_vm._v("Sarah")]), _vm._v(" "), _c('span', {
    staticClass: "s87ff s3fc s71fs s47ls",
    staticStyle: {
      "position": "absolute",
      "left": "108px",
      "width": "114px"
    }
  }, [_vm._v("Chudnow")]), _vm._v(" "), _c('span', {
    staticClass: "s87ff s3fc s71fs s89ls",
    staticStyle: {
      "position": "absolute",
      "left": "219px",
      "width": "100px"
    }
  }, [_vm._v("Campus")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.1364, 358.0180, 175.6333)",
      "-webkit-transform-origin": "0px 22.475727px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s87ff s3fc s71fs s64ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "66px"
    }
  }, [_vm._v("—D.L. ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.1364, 293.4369, 239.1137)",
      "-webkit-transform-origin": "0px 22.475727px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s87ff s3fc s71fs s63ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "38px"
    }
  }, [_vm._v("For")]), _vm._v(" "), _c('span', {
    staticClass: "s87ff s3fc s71fs s89ls",
    staticStyle: {
      "position": "absolute",
      "left": "38px",
      "width": "40px"
    }
  }, [_vm._v("my")]), _vm._v(" "), _c('span', {
    staticClass: "s87ff s3fc s71fs s91ls",
    staticStyle: {
      "position": "absolute",
      "left": "78px",
      "width": "57px"
    }
  }, [_vm._v("dear")]), _vm._v(" "), _c('span', {
    staticClass: "s87ff s3fc s71fs s89ls",
    staticStyle: {
      "position": "absolute",
      "left": "135px",
      "width": "60px"
    }
  }, [_vm._v("Caro ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0001, 0.0000, 0.0000, 1.1364, 352.4320, 270.8530)",
      "-webkit-transform-origin": "0px 22.475727px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s87ff s3fc s71fs s53ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "79px"
    }
  }, [_vm._v("—M.A. ")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e691844","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pg_4.vue
// module id = 63
// module chunks = 0